import { useAppSelector } from '@/redux/hooks/useAppSelector'
import { selectRecentlyViewed } from '@/store/charts/chartsSelectors'
import { getRecentlyViewedCharts, type RecentlyViewedChart } from './recentlyViewed'

/**
 * Returns the recently viewed charts from Redux, which is seeded from
 * localStorage on app load and kept live so that status changes (e.g. ID
 * verification badge updates) are reflected without a page remount.
 *
 * Falls back to a direct localStorage read when the Redux state is undefined
 * (e.g. redux-persist rehydrating a pre-recentlyViewed persisted state).
 */
export function useRecentlyViewedCharts(): RecentlyViewedChart[] {
  return useAppSelector(selectRecentlyViewed) ?? getRecentlyViewedCharts()
}
